import React from 'react'
import { Platform, Pressable } from 'react-native'
import { router } from 'expo-router'
import { useTranslation } from 'react-i18next'
import useAnimatedPress from '@ui/animated/useAnimatedPress'
import TileBlur from '@ui/tiles/TileBlur'
import Button from '@ui/buttons/Button'

export default function FramesSection() {
  const { animation, onPressIn, onPressOut } = useAnimatedPress()
  const { t } = useTranslation(['customer'])
  const text = 'customer:home.sections.frames'

  const onPress = () => router.navigate('/frame/search')

  return (
    <Pressable
      onPress={onPress}
      onPressIn={onPressIn}
      onPressOut={onPressOut}
      className="flex-1"
    >
      <TileBlur
        title={t(`${text}.title`)}
        desc={t(`${text}.desc`)}
        cta={
          <Button
            noninteractive
            animation={animation}
            onPress={onPress}
            size="sm"
            variant="outlined"
            label={t(`${text}.cta`)}
          />
        }
        glassProps={{
          animation,
          image: require('@/images/frames-plenty.png'),
          imageWrapperStyle: {
            width: '125%',
            height: '125%',
            transform: [{ rotate: '10deg' }],
            transformOrigin: 'bottom right',
          },
          imageStyle: {
            transform: [{ translateX: 33 }, { translateY: 66 }],
          },
          blur: Platform.select({ default: 60, web: 6 }),
          blurStyle: {
            opacity: Platform.select({ default: 0.7, web: 0.7 }),
            transform: [
              { translateX: Platform.select({ default: -30, web: 6 }) },
              { translateY: 27 },
              { scale: 0.6 },
              { rotate: '10deg' },
            ],
          },
        }}
        classNameDesc="pr-20"
      />
    </Pressable>
  )
}
